"use client"

import { useRouter } from 'next/navigation';
import { getUser, updateAdvertisement } from '@/app/actions'; // Import the updateAdvertisement function
import { useState } from 'react';
import { Trash, Share, Lightning } from '@phosphor-icons/react/dist/ssr';
import { RecordModel } from 'pocketbase';
import { useQuery } from '@tanstack/react-query';

const AdvertActions = ({ advert }: { advert: any }) => {
  const router = useRouter();
  const [isPublishing, setIsPublishing] = useState(false);
  const { data: currentUser } = useQuery({
    queryKey: ["user"],
    queryFn: getUser,
    staleTime: Infinity,
  });

  const handleEdit = () => {
    const path = `/classifieds/new?adId=${advert.id}&step=8`;
    router.push(path);
  };

  const handlePublish = async () => {
    setIsPublishing(true);
    try {
      await updateAdvertisement(advert.id, { status: 'active' });
      router.refresh();
    } catch (error) {
      console.error('Failed to publish advertisement:', error);
    } finally {
      setIsPublishing(false);
    }
  };

  const handleDelete = async () => {
    if (!confirm("Are you sure you want to delete this advertisement?")) return;
    try {
      // Update the advertisement status to 'deleted'
      const newStatus = advert.status === 'draft' ? 'deleted-draft' : 'deleted';
      await updateAdvertisement(advert.id, { status: newStatus });
      router.refresh();
    } catch (error) {
      console.error("Failed to delete advertisement:", error);
    }
  };

  const handleBoost = async () => {
    const path = `/classifieds/new?adId=${advert.id}&step=7`;
    router.push(path);
  };

  return (advert.user.id === (currentUser as unknown as RecordModel).id) ? (
    <div className="flex gap-4 flex-wrap">
      {advert.status !== 'active' && (
        <button 
          className="bg-primary text-white px-4 py-2 rounded-full flex flex-row items-center"
          onClick={handlePublish}
          disabled={isPublishing}
        >
          <Share size={18} weight="bold" className="mr-2" />
          {isPublishing ? 'Publishing...' : 'Publish'}
        </button>
      )}
      <button 
        className="bg-secondary text-white px-4 py-2 rounded-full flex items-center"
        onClick={handleEdit}
      >
        <svg
          className="w-4 h-4 mr-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
          />
        </svg>
        Edit
      </button>
      <button 
        className="bg-accent/80 text-white px-4 py-2 rounded-full flex items-center"
        onClick={handleDelete}
      >
        <Trash weight="fill" className="mr-2" />
        Delete
      </button>
      <button 
        className="bg-secondary text-white px-4 py-2 rounded-full flex items-center"
        onClick={handleBoost}
      >
        <Lightning weight="fill" className="mr-2" />
        Boost
      </button>
    </div>
  ) : (<></>);
};

export default AdvertActions;